var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"poster"},[_c('img',{attrs:{"src":_vm.img,"width":"100%"}}),_vm._v(" "),_c('div',{staticClass:"poster-title"},[_vm._v("长按保存图片")]),_vm._v(" "),_c('Floating')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f438bd8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/retails/share.vue
// module id = null
// module chunks = 